module.exports = __webpack_public_path__ + "why15.png?e21e4d289aebb108343bc08779ae4be1";